import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Pet } from '../../../../models/pet.model';
import { AbPet } from 'app/abstract/full-pages/meus-dados/pet.abstract';

@Injectable({ providedIn: 'root' })
export class PetService extends AbPet {

  constructor(http: HttpClient) {
    super(http);
  }


  desativarPet(id: number) {
    return this.delete(`pet/desativar/`, id);
  }

  public getAllPets(pessoaUnidadeId: number): Observable<any> {
    return this.get(`pet/pessoa_unidade_pets/${pessoaUnidadeId}`);
  }

  public savePet(pet: Pet): Observable<any> {
    return this.save("pet/", pet);
  }
}
